import React from 'react'
import { useMessageBus } from '.'

const triggerAction = (action, args) => {
  const actionArgs = Array.isArray(args) ? args : [args]
  window.parent.postMessage({
    action,
    args: actionArgs
  }, '*')
}

const useIntegrationProvider = () => {
  const messageBus = useMessageBus()

  const handleMessage = (e) => {
    messageBus.emit(e.data.action, e.data.data)
  }

  React.useEffect(() => {
    window.addEventListener('message', handleMessage)
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const integrationProvider = {
    emit: triggerAction,
  }

  return [integrationProvider, messageBus]
}

export {
  useIntegrationProvider,
}
